import React from "react";
import styled from "styled-components";

export default ({ animated = true, color = "white" }) => {
  const definitions = (
    <defs>
      <path
        d="M17.8950018,137.22572 L17.8950018,137.22572 L17.8950018,137.22572 C18.2097513,137.182467 18.4999692,137.402559 18.5432217,137.717309 C18.5467881,137.743261 18.5485775,137.769428 18.5485775,137.795624 L18.5485775,218.35881 L18.5485775,218.35881 C18.5485775,218.731049 18.2468187,219.032807 17.8745803,219.032807 L17.8745803,219.032807 L17.8745803,219.032807 C17.502528,219.032807 17.2009199,218.731199 17.2009199,218.359147 C17.2009199,218.359035 17.20092,218.358923 17.20092,218.35881 L17.2410964,137.975251 L17.2410964,137.975251 C17.2412854,137.597161 17.5204318,137.277193 17.8950018,137.22572 Z"
        id="path-1"
      />
      <filter
        x="-167.0%"
        y="-2.8%"
        width="434.0%"
        height="105.5%"
        filterUnits="objectBoundingBox"
        id="filter-2"
      >
        <feGaussianBlur
          stdDeviation="1.5"
          in="SourceAlpha"
          result="shadowBlurInner1"
        />
        <feOffset
          dx="0"
          dy="1"
          in="shadowBlurInner1"
          result="shadowOffsetInner1"
        />
        <feComposite
          in="shadowOffsetInner1"
          in2="SourceAlpha"
          operator="arithmetic"
          k2="-1"
          k3="1"
          result="shadowInnerInner1"
        />
        <feColorMatrix
          values="0 0 0 0 1   0 0 0 0 1   0 0 0 0 1  0 0 0 1 0"
          type="matrix"
          in="shadowInnerInner1"
        />
      </filter>
      <path
        d="M15.1368148,19.0475668 L15.1368148,31.4242522 C15.2345781,31.8424806 15.7959759,32.048066 16.8210082,32.0410084 C17.8460405,32.0339508 18.4074383,31.8283654 18.5052015,31.4242522 L18.5052015,19.0475668"
        id="path-3"
      />
      <filter
        x="-37.1%"
        y="-9.6%"
        width="174.2%"
        height="119.2%"
        filterUnits="objectBoundingBox"
        id="filter-4"
      >
        <feMorphology
          radius="1"
          operator="erode"
          in="SourceAlpha"
          result="shadowSpreadInner1"
        />
        <feGaussianBlur
          stdDeviation="0.5"
          in="shadowSpreadInner1"
          result="shadowBlurInner1"
        />
        <feOffset
          dx="0"
          dy="0"
          in="shadowBlurInner1"
          result="shadowOffsetInner1"
        />
        <feComposite
          in="shadowOffsetInner1"
          in2="SourceAlpha"
          operator="arithmetic"
          k2="-1"
          k3="1"
          result="shadowInnerInner1"
        />
        <feColorMatrix
          values="0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.131085824 0"
          type="matrix"
          in="shadowInnerInner1"
        />
      </filter>
      <path
        d="M0.181088314,2.5032175 L0.181088314,10.2216491 C5.2504985,11.5630767 11.0060301,12.2309189 17.4476832,12.2251758 C22.6184737,12.2205657 26.9319497,11.7893346 30.3881112,10.9314826 C30.9544084,10.7909223 31.7520669,10.5543111 32.7810868,10.2216491 L32.7810868,2.5032175 C27.9321019,1.02279741 22.8209674,0.282587359 17.4476832,0.282587359 C12.0743991,0.282587359 6.31886746,1.02279741 0.181088314,2.5032175 Z"
        id="path-5"
      />
      <filter
        x="-4.6%"
        y="-12.6%"
        width="109.2%"
        height="125.1%"
        filterUnits="objectBoundingBox"
        id="filter-6"
      >
        <feGaussianBlur
          stdDeviation="1"
          in="SourceAlpha"
          result="shadowBlurInner1"
        />
        <feOffset
          dx="1"
          dy="1"
          in="shadowBlurInner1"
          result="shadowOffsetInner1"
        />
        <feComposite
          in="shadowOffsetInner1"
          in2="SourceAlpha"
          operator="arithmetic"
          k2="-1"
          k3="1"
          result="shadowInnerInner1"
        />
        <feColorMatrix
          values="0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.361979167 0"
          type="matrix"
          in="shadowInnerInner1"
        />
      </filter>
      <linearGradient x1="50%" y1="0%" x2="50%" y2="100%" id="linearGradient-7">
        <stop stopColor="#FFFFFF" stopOpacity="0" offset="35.2359694%" />
        <stop stopColor="#FFFFFF" offset="100%" />
      </linearGradient>
      <polygon
        id="EchoVRPath"
        points="1.3473547 140.237636 33.9297055 140.153416 33.9297055 65.1299871 1.3473547 65.1299871"
      />
      <path
        d="M0,66.4041165 C4.3425681,65.4179358 9.84007025,64.924423 16.4925064,64.9235783 C23.1449426,64.9227335 28.5024321,65.4350254 32.564975,66.460454 L32.564975,69.4308377 C31.3144303,70.5276098 25.9569408,71.0463671 16.4925064,70.9871095 C7.02807204,70.9278518 1.5305699,70.3977156 0,69.3967008 L0,66.4041165 Z"
        id="path-9"
      />
      <path
        d="M12.3230282,-100.65255343 L20.6112047,-100.65255343 L20.6112047,66.9899975 C20.1575421,67.4405322 18.7761793,67.6688977 16.4671164,67.6750941 C14.1580536,67.6812906 12.7766908,67.452925 12.3230282,66.9899975 L12.3230282,1.65255343 Z"
        id="path-10"
      />
      <linearGradient
        x1="50%"
        y1="95.7843703%"
        x2="50%"
        y2="83.1984116%"
        id="linearGradient-11"
      >
        <stop stopColor="#FFFFFF" stopOpacity="0" offset="0%" />
        <stop
          stopColor="#FFFFFF"
          stopOpacity="0.516701212"
          offset="37.0926244%"
        />
        <stop stopColor="#FFFFFF" offset="100%" />
      </linearGradient>
      <linearGradient
        x1="50%"
        y1="96.1019356%"
        x2="50%"
        y2="94.6900424%"
        id="linearGradient-12"
      >
        <stop stopColor="#FFFFFF" offset="0%" />
        <stop stopColor="#FFFFFF" stopOpacity="0" offset="100%" />
      </linearGradient>
      <path
        d="M33.9582821,140.119291 L34.0241381,140.119291 L34.0241381,48.6087516 C30.3150076,49.9129 24.794024,50.5818371 17.4611873,50.6155629 C10.1283506,50.6492888 4.607367,49.9803517 0.898236465,48.6087516 L0.898236465,140.119291 L0.922378678,140.119291 C4.6924049,141.456198 10.2047254,142.116858 17.4593451,142.10127 C24.6896126,142.085734 30.1892583,141.425074 33.9582821,140.119291 Z"
        id="path-13"
      />
      <linearGradient
        x1="13.7947182%"
        y1="50%"
        x2="0%"
        y2="50%"
        id="linearGradient-14"
      >
        <stop stopColor="#FFFFFF" stopOpacity="0" offset="0%" />
        <stop stopColor="#000000" offset="100%" />
      </linearGradient>
      <path
        d="M33.1390757,91.9535204 L33.1864009,91.9535204 L33.1864009,0.44298124 C29.4704962,2.11070603 23.9394294,2.96143135 16.5932005,2.99515719 C9.2469715,3.02888303 3.71590468,2.17815771 0,0.44298124 L0,91.9535204 L0.0152553989,91.9535204 C3.82022659,93.9264875 9.35953598,94.9042129 16.6331836,94.8866966 C23.8884117,94.8692246 29.3903757,93.8914993 33.1390757,91.9535204 Z"
        id="path-15"
      />
      <linearGradient
        x1="86.7973352%"
        y1="50%"
        x2="100%"
        y2="50%"
        id="linearGradient-16"
      >
        <stop stopColor="#FFFFFF" stopOpacity="0" offset="0%" />
        <stop stopColor="#000000" offset="100%" />
      </linearGradient>
      <path
        d="M33.1390757,91.9535204 L33.1864009,91.9535204 L33.1864009,0.44298124 C29.4704962,2.11070603 23.9394294,2.96143135 16.5932005,2.99515719 C9.2469715,3.02888303 3.71590468,2.17815771 0,0.44298124 L0,91.9535204 L0.0152553989,91.9535204 C3.82022659,93.9264875 9.35953598,94.9042129 16.6331836,94.8866966 C23.8884117,94.8692246 29.3903757,93.8914993 33.1390757,91.9535204 Z"
        id="path-17"
      />
    </defs>
  );

  return (
    <g id="Needle" transform="translate(357.818912, -200.000000)">
      {definitions}
      <g id="needleMetalTip">
        <use fill="#D8D8D8" fillRule="evenodd" xlinkHref="#path-1" />
        <use
          fill="black"
          fillOpacity="1"
          filter="url(#filter-2)"
          xlinkHref="#path-1"
        />
        <path
          stroke="#979797"
          strokeWidth="0.5"
          d="M17.9290366,137.473392 C17.6781757,137.507865 17.4912229,137.722158 17.4910964,137.975376 L17.45092,218.358935 L17.4509199,218.359147 C17.4509199,218.593128 17.6405992,218.782807 17.8745803,218.782807 C18.1087475,218.782807 18.2985775,218.592977 18.2985775,218.35881 L18.2985775,137.795624 C18.2985775,137.780812 18.2975657,137.766018 18.2955492,137.751343 C18.2710937,137.57338 18.1070004,137.448937 17.9290366,137.473392 Z"
        />
        <use
          strokeOpacity="0.629161005"
          stroke="#979797"
          strokeWidth="0.5"
          xlinkHref="#path-1"
        />
      </g>
      <g id="just-the-tip" transform="translate(1.000000, 136.722008)">
        <g id="MetalNeedleHolder">
          <use fill="#D8D8D8" fillRule="evenodd" xlinkHref="#path-3" />
          <use
            fill="black"
            fillOpacity="1"
            filter="url(#filter-4)"
            xlinkHref="#path-3"
          />
          <use stroke="#979797" strokeWidth="0.5" xlinkHref="#path-3" />
        </g>
        <path
          d="M13.464133,12.0421746 L13.464133,20.3952976 C14.0696996,20.623755 15.1898266,20.7458358 16.8245142,20.7615402 C18.4592017,20.7772445 19.5793287,20.6551636 20.1848953,20.3952976 L20.1848953,12.0421746"
          id="PlasticNeedleHolder"
          fill="#34495E"
        />
        <g id="plasticBase">
          <use fill="#34495E" fillRule="evenodd" xlinkHref="#path-5" />
          <use
            fill="black"
            fillOpacity="1"
            filter="url(#filter-6)"
            xlinkHref="#path-5"
          />
        </g>
      </g>
      <path
        d="M0.898236465,48.8272423 C6.4031521,47.4800354 11.9080677,46.806432 17.4129834,46.806432 C22.917899,46.806432 28.4228146,47.4800354 33.9277303,48.8272423"
        id="TopOfNeedleBodyBack"
        stroke="#979797"
        strokeWidth="0.5"
      />
      <g id="EchoVR" opacity="0.97509058">
        <use fillOpacity="0.469999999" fill="#BBE2FF" xlinkHref="#EchoVRPath" />
        <use
          fillOpacity="0.87"
          fill="url(#linearGradient-7)"
          xlinkHref="#EchoVRPath"
        />
      </g>
      <g id="plunger" transform="translate(1.347355, 0.000000)">
        <g id="plungerRound">
          <use fill="#4B4B4B" fillRule="evenodd" xlinkHref="#path-9" />
          <path
            stroke="#484646"
            strokeWidth="0.5"
            d="M0.25,66.604206 L0.25,69.2561639 C1.8735209,70.1741777 7.3221241,70.679688 16.4940717,70.7371144 C25.6580507,70.7944908 30.9797239,70.3002725 32.314975,69.3113365 L32.314975,66.6557957 C28.2981712,65.6674592 23.0231732,65.172749 16.4925382,65.1735783 C9.95651726,65.1744083 4.54176627,65.6517328 0.25,66.6042125 Z"
          />
        </g>
        <g id="plungerStick">
          <use fill="#4B4B4B" fillRule="evenodd" xlinkHref="#path-10" />
          <path
            stroke="#FFFFFF"
            strokeWidth="0.5"
            d="M12.0730282,-100.40255343 L20.8612047,-100.40255343 L20.8612047,66.9899975 L20.7873688,67.1673847 C20.2669693,67.684196 18.8484475,67.9187047 16.4677873,67.9250932 C14.0858789,67.9314851 12.6655283,67.6966742 12.1444737,67.1649784 L12.0730282,66.9899975 L12.0730282,1.40255343 Z"
          />
        </g>
      </g>
      <g id="NeedleBody">
        <use
          fill="url(#linearGradient-12)"
          fillRule="evenodd"
          xlinkHref="#path-13"
        />
        <path
          stroke="#979797"
          strokeWidth="0.5"
          d="M33.7741381,139.918207 L33.7741381,48.9583743 C30.0405998,50.1985133 24.6053178,50.8327077 17.4623371,50.8655603 C10.319778,50.898411 4.88374916,50.2663266 1.14823646,48.9641271 L1.14823646,139.933515 C4.88276827,141.22575 10.3215086,141.866606 17.4588079,141.85127 C24.5983722,141.835929 30.0386857,141.190049 33.7741384,139.918202 Z"
        />
      </g>
      <path
        d="M0.898236465,139.702522 C6.4031521,138.383037 11.9080677,137.723295 17.4129834,137.723295 C22.917899,137.723295 28.4228146,138.383037 33.9277303,139.702522"
        id="needleBackLine"
        stroke="#979797"
        strokeWidth="0.5"
        strokeDasharray="2,1"
      />
      <path
        d="M16.1682564,139.923485 C16.30416,140.371764 16.7073152,140.592461 17.377722,140.585578 C18.0481287,140.578694 18.462396,140.367324 18.6205238,139.951469 C18.4727361,139.471953 18.0584688,139.229894 17.377722,139.225292 C16.6969751,139.22069 16.2938199,139.453421 16.1682564,139.923485 Z"
        id="needleEntrance"
        stroke="#979797"
        strokeWidth="0.5"
        fill="#D8D8D8"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <g
        id="Measure-marks"
        transform="translate(6.736773, 80.649936)"
        stroke="#979797"
        strokeWidth="0.5"
        strokeLinecap="round"
      >
        <path
          d="M0.062293333,47.2600729 C1.88893351,47.9254113 5.32439095,48.2580805 10.3686657,48.2580805 C15.4129404,48.2580805 18.8483978,47.9254113 20.675038,47.2600729"
          id="measureMark1"
        />
        <path
          d="M0.062293333,35.4529807 C1.88893351,36.118319 5.32439095,36.4509882 10.3686657,36.4509882 C15.4129404,36.4509882 18.8483978,36.118319 20.675038,35.4529807"
          id="measureMark2"
        />
        <path
          d="M0.062293333,23.6458884 C1.88893351,24.3112268 5.32439095,24.643896 10.3686657,24.643896 C15.4129404,24.643896 18.8483978,24.3112268 20.675038,23.6458884"
          id="measureMark3"
        />
        <path
          d="M0.062293333,11.8387962 C1.88893351,12.5041346 5.32439095,12.8368038 10.3686657,12.8368038 C15.4129404,12.8368038 18.8483978,12.5041346 20.675038,11.8387962"
          id="measureMark4"
        />
        <path
          d="M0.062293333,0.0317039396 C1.88893351,0.697042318 5.32439095,1.02971151 10.3686657,1.02971151 C15.4129404,1.02971151 18.8483978,0.697042318 20.675038,0.0317039396"
          id="measureMark5"
        />
      </g>
      <g id="shadow" opacity="0.1" transform="translate(0.898236, 48.608752)">
        <g id="left-shadow">
          <use
            fill="url(#linearGradient-14)"
            fillRule="evenodd"
            xlinkHref="#path-15"
          />
          <path
            stroke="#979797"
            strokeWidth="0.5"
            d="M0.25,91.793003 C0.209918452,91.7726385 0.170030306,91.7521649 0.130335565,91.7315823 L0.0152553989,91.7035204 L0,91.7035204 L0,91.9535204 L0.25,91.9535204 L0.25,91.793003 Z M0.25,0.83057396 L0.25,0.44298124 L-0.105775807,0.669501611 C0.0110644858,0.72406128 0.129656366,0.777751983 0.25,0.83057396 Z M32.9364009,0.824526835 C33.0555762,0.774160317 33.1730311,0.723005881 33.2887658,0.671063313 L32.9364009,0.44298124 L32.9364009,0.824526835 Z M32.9364009,91.7765271 L32.9364009,91.9535204 L33.1864009,91.9535204 L33.1864009,91.7035204 L33.1390757,91.7035204 L33.0242669,91.7314418 C32.9950872,91.7465269 32.9657986,91.7615535 32.9364011,91.7765215 Z M32.9364011,91.7765215 C29.2306288,93.6633509 23.7947601,94.6194494 16.6325815,94.6366973 C9.47198139,94.6539414 4.01001068,93.7033796 0.25,91.793003 L0.25,0.83057396 C3.99763795,2.47551052 9.44407518,3.27798078 16.5943482,3.24515455 C23.7448894,3.2123271 29.1904832,2.40764746 32.9364009,0.824526835 L32.9364009,91.7765271 Z"
          />
        </g>
        <g id="right-shadow">
          <use
            fill="url(#linearGradient-16)"
            fillRule="evenodd"
            xlinkHref="#path-17"
          />
          <path
            stroke="#979797"
            strokeWidth="0.5"
            d="M32.9364009,91.7765271 L32.9364009,0.824526835 C29.1904832,2.40764746 23.7448894,3.2123271 16.5943482,3.24515455 C9.44407518,3.27798078 3.99763795,2.47551052 0.25,0.83057396 L0.25,91.793003 C4.01001068,93.7033796 9.47198139,94.6539414 16.6325815,94.6366973 C23.7947601,94.6194494 29.2306288,93.6633509 32.9364011,91.7765215 Z"
          />
        </g>
      </g>
    </g>
  );
};



// WEBPACK FOOTER //
// ./src/components/Needle.js